export default __webpack_public_path__ + "static/media/parentalcontrol.54e7441a.svg";